import Image from 'next/image';

import { Box } from '@chakra-ui/react';

import { CLAUDE_ENGINEER_ASSETS } from '~/features/claude-engineer-2026/constants';

type ClaudeLogoSize = 'catalog' | 'experience' | 'hero';

const LOGO_CONFIG: Record<ClaudeLogoSize, { height: number; src: string; width: number }> = {
  catalog: {
    height: 20,
    src: CLAUDE_ENGINEER_ASSETS.claudeLogoCatalog,
    width: 93,
  },
  experience: {
    height: 20,
    src: CLAUDE_ENGINEER_ASSETS.claudeLogoExperience,
    width: 90,
  },
  hero: {
    height: 32,
    src: CLAUDE_ENGINEER_ASSETS.claudeLogoHero,
    width: 148,
  },
};

export function ClaudeLogo({ size }: { size: ClaudeLogoSize }) {
  const { height, src, width } = LOGO_CONFIG[size];

  return (
    <Box height={`${height}px`} position='relative' width={`${width}px`}>
      <Image alt='Claude' src={src} style={{ objectFit: 'contain' }} fill />
    </Box>
  );
}
